export const PRIMARY_COLOR = "#A435F0";
